export default __webpack_public_path__ + "static/logo-4c7b6bc84c03562eb01cb120eae38799.png";